'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeAttachmentFromThread = undefined;

var _fileUploadGetters = require('conversations-internal-schema/file-upload/operators/fileUploadGetters');

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

var _identifierForThread = require('../../file-uploads/operators/identifierForThread');

var _removeAttachment = require('../../file-uploads/actions/removeAttachment');

var removeAttachmentFromThread = exports.removeAttachmentFromThread = function removeAttachmentFromThread(_ref) {
  var attachment = _ref.attachment,
      thread = _ref.thread;
  return function (dispatch) {
    var threadIdentifier = (0, _identifierForThread.identifierForThread)(thread);

    var localId = (0, _fileUploadGetters.getLocalId)(attachment);

    dispatch((0, _removeAttachment.removeAttachment)({ localId: localId, threadId: threadIdentifier }));

    dispatch((0, _trackInteraction.trackInteraction)('remove-staged-attachment', {
      action: 'remove staged attachment'
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/actions/removeAttachmentFromThread.js
// module id = 660
// module chunks = 2 3